import { CsvDriver } from "@dhx/ts-data";
import { getCellNameByIndex } from "./main";
import { IGrid } from "@dhx/ts-grid";

export class CustomCsvDriver extends CsvDriver {
	private _grid: IGrid
	constructor(grid: IGrid) {
		super();
		this._grid = grid;
	}
	toJsonArray(data: string): any[] {
		const dataArr = super.toJsonArray(data);
		const d = dataArr.reduce((total, item, i) => {
			for (const key in item) {
				total.push({
					value: item[key],
					cell: getCellNameByIndex(i, parseFloat(key), this._grid),
				});
			}
			return total;
		}, []);
		return d;
	}
}
